"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
require("../../styles/VsPumpSpeedSettingComponent.css");
var _index = _interopRequireDefault(require("../../common_features/assets/images/index"));
const VsPumpSpeedSettingComponent = _ref => {
  let {
    totalPage,
    currentPage,
    navHeading,
    rightNavHeading,
    handleCancle,
    handleBack,
    headerText,
    subContent,
    list,
    handleClick,
    // selected,
    continueBtnTitle,
    continueBtnClick,
    continueBtnDisabled,
    sequence,
    handleBtnSelect,
    modelNumber
  } = _ref;
  const handleSelectedColour = item => {
    return item.isSelected ? item.color : "#9A9A9A";
  };
  const handleSelectedBackground = item => {
    return item.isSelected ? "transparent" : "#F4F4F4";
  };
  const handleSelectedBorder = item => {
    return item.isSelected ? "1px solid #333333" : "#F4F4F4";
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: navHeading,
    rightNavHeading: rightNavHeading,
    handleCancle: handleCancle,
    handleBack: handleBack,
    leftArrowImage: _index.default.leftArrow.default
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "PageCount",
    style: {
      paddingLeft: 22,
      paddingTop: 15,
      fontFamily: "poppins",
      fontSize: 18
    }
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, "Step ", currentPage, " "), "of ", totalPage), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-body-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-heading"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "header-text",
    headerText: headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-subContent"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "sub-text",
    headerText: subContent
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "model-number-label"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: modelNumber
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-btnDiv-wrapper"
  }, list === null || list === void 0 ? void 0 : list.map(item => {
    var _item$name;
    return /*#__PURE__*/_react.default.createElement("button", {
      key: item.name,
      style: {
        color: handleBtnSelect(list) ? handleSelectedColour(item) : item.color,
        background: handleBtnSelect(list) ? handleSelectedBackground(item) : "transparent",
        border: handleBtnSelect(list) ? handleSelectedBorder(item) : "1px solid #333333"
      },
      "data-testid": "speedSetting-btn",
      className: "speedSettingBtn ".concat(item.isSelected ? "speedSettingBtn-selected" : "", " ").concat(item.isSelected && "speedSetting-notSelected"),
      onClick: () => handleClick(sequence, item.name, item)
    }, console.log(item.isSelected, "item.isSelected "), (item === null || item === void 0 ? void 0 : (_item$name = item.name) === null || _item$name === void 0 ? void 0 : _item$name.length) > 12 ? "".concat(item === null || item === void 0 ? void 0 : item.name.slice(0, 12), "...") : item === null || item === void 0 ? void 0 : item.name, item.isSelected && /*#__PURE__*/_react.default.createElement("span", {
      className: "customTick \n                      }"
    }, /*#__PURE__*/_react.default.createElement("img", {
      className: "right-tick-vsPump",
      src: _index.default.rightTick.default,
      alt: ""
    })));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "speedSetting-conti-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: continueBtnTitle,
    onClick: () => continueBtnClick(sequence),
    disabled: continueBtnDisabled
  })))));
};
var _default = exports.default = VsPumpSpeedSettingComponent;